var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { CameraResultType, Camera, CameraSource } from '@capacitor/camera';
import { imageResize } from './image-resize-handler.util';
function resizeImage(dataUrl, resolutionLimit) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2, new Promise(function (resolve) {
                    var img = new Image();
                    img.onload = function () {
                        var canvas = document.createElement('canvas');
                        var width = img.width, height = img.height;
                        if (width > height) {
                            if (width > resolutionLimit) {
                                height *= resolutionLimit / width;
                                width = resolutionLimit;
                            }
                        }
                        else {
                            if (height > resolutionLimit) {
                                width *= resolutionLimit / height;
                                height = resolutionLimit;
                            }
                        }
                        canvas.width = width;
                        canvas.height = height;
                        var ctx = canvas.getContext('2d');
                        ctx.drawImage(img, 0, 0, width, height);
                        resolve(canvas.toDataURL('image/jpeg', 0.9));
                    };
                    img.src = dataUrl;
                })];
        });
    });
}
var getImageSourceFromCamera = function (resolutionLimit) {
    if (resolutionLimit === void 0) { resolutionLimit = 100; }
    return __awaiter(void 0, void 0, void 0, function () {
        var imageSrc, resizedImage, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    return [4, Camera.getPhoto({
                            allowEditing: true,
                            resultType: CameraResultType.DataUrl,
                            source: CameraSource.Camera,
                        })];
                case 1:
                    imageSrc = _a.sent();
                    return [4, imageResize(imageSrc.dataUrl, resolutionLimit, null, null)];
                case 2:
                    resizedImage = _a.sent();
                    return [2, resizedImage];
                case 3:
                    error_1 = _a.sent();
                    return [2, undefined];
                case 4: return [2];
            }
        });
    });
};
var getImageSourceFromFileSystem = function (resolutionLimit) {
    if (resolutionLimit === void 0) { resolutionLimit = 100; }
    return __awaiter(void 0, void 0, void 0, function () {
        var imageSrc, resizedImage, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    return [4, Camera.getPhoto({
                            resultType: CameraResultType.DataUrl,
                            source: CameraSource.Photos,
                        })];
                case 1:
                    imageSrc = _a.sent();
                    return [4, imageResize(imageSrc.dataUrl, resolutionLimit, null, null)];
                case 2:
                    resizedImage = _a.sent();
                    return [2, resizedImage];
                case 3:
                    error_2 = _a.sent();
                    return [2, undefined];
                case 4: return [2];
            }
        });
    });
};
export function getImageSourceFromFileSystemOffline(resolutionLimit) {
    if (resolutionLimit === void 0) { resolutionLimit = 100; }
    return __awaiter(this, void 0, void 0, function () {
        var _this = this;
        return __generator(this, function (_a) {
            return [2, new Promise(function (resolve) {
                    var input = document.createElement('input');
                    input.type = 'file';
                    input.accept = 'image/*';
                    input.onchange = function () { return __awaiter(_this, void 0, void 0, function () {
                        var file, reader;
                        var _this = this;
                        var _a;
                        return __generator(this, function (_b) {
                            file = (_a = input.files) === null || _a === void 0 ? void 0 : _a[0];
                            if (!file) {
                                resolve(undefined);
                                return [2];
                            }
                            reader = new FileReader();
                            reader.onload = function (event) { return __awaiter(_this, void 0, void 0, function () {
                                var dataUrl, resized;
                                var _a;
                                return __generator(this, function (_b) {
                                    switch (_b.label) {
                                        case 0:
                                            dataUrl = (_a = event.target) === null || _a === void 0 ? void 0 : _a.result;
                                            return [4, resizeImage(dataUrl, resolutionLimit)];
                                        case 1:
                                            resized = _b.sent();
                                            resolve(resized);
                                            return [2];
                                    }
                                });
                            }); };
                            reader.onerror = function () { return resolve(undefined); };
                            reader.readAsDataURL(file);
                            return [2];
                        });
                    }); };
                    input.click();
                })];
        });
    });
}
var getPdfFromFileSystem = function () {
    return new Promise(function (resolve) {
        var input = document.createElement('input');
        input.type = 'file';
        input.accept = '.pdf';
        input.onchange = function (e) {
            var _a;
            var file = (_a = e.target.files) === null || _a === void 0 ? void 0 : _a[0];
            if (!file)
                return resolve(undefined);
            var reader = new FileReader();
            reader.onload = function () { return resolve(reader.result); };
            reader.readAsDataURL(file);
        };
        input.click();
    });
};
export { getImageSourceFromCamera, getImageSourceFromFileSystem, imageResize, getPdfFromFileSystem, };
//# sourceMappingURL=file-select.utils.js.map